<template>
  <div class="menu-wrap">
    <div class="sidebar-header">
      <p>{{ user.first_name }} {{ user.surname }}</p>
    </div>
    <el-menu
      mode="vertical"
      text-color="#fff"
      active-text-color="#d40c41"
      router
      :default-active="$route.path"
    >
      <el-menu-item index="/content/home">
        <i class="fas fa-chart-line"></i>
        <p>Home</p>
      </el-menu-item>
      <hr />
      <el-menu-item index="/content/profile">
        <i class="fas fa-user-circle"></i>
        <p>My Profile</p>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      url: process.env.VUE_APP_STORAGE_URL
    }
  },

  computed: {
    ...mapState('auth', ['user'])
  }
}
</script>

<style lang="scss" scoped>
.el-menu {
  margin-top: 4rem;
  .el-menu-item {
    height: 50px;
    display: flex;
    align-items: center;
    margin: 0.3rem 1.5rem;
    background: transparent;
    font-size: 16px !important;
    padding-left: 25px !important;
    color: #3d3365 !important;
    p {
      display: flex;
      margin: 8px;
      justify-content: center;
    }
    .el-icon-s-data {
      width: auto;
      margin-top: -2px;
    }
    svg {
      width: 1.2rem;
      height: 1.2rem;
      margin-right: 12px;
    }
    &:hover,
    &.is-active {
      font-family:"F37 Ginger Pro Bold";
      background: #edecf4;
      border-radius: 11px;
      i {
        color: #d40c41;
        font-size: 19px;
      }
      #vc_path {
        fill: #d40c41;
      }
    }
  }
  hr {
    width: 80%;
    margin: 1rem auto;
    border: 1px solid #f1f1f1;
  }
}
</style>
